var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import history from 'helpers/History';
import { Col, Modal, ModalBody, Row } from 'reactstrap';
import PacketTicketPapel from '../components/PacketTicketPapel';
import theme from 'Theme';
import { _width, widthFunc } from '../../../components/Ticket/helpers/Const';
var PacketTicketDetail = /** @class */ (function (_super) {
    __extends(PacketTicketDetail, _super);
    function PacketTicketDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnSelectItem = function (item) {
            console.error(item.id);
        };
        _this.handleOnToggle = function () {
            history.goBack();
        };
        _this.handleOnRefunded = function (packetTicket) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.store.reports.cancelPacketTicket(packetTicket, this.props.store.users.user)
                    .then(function (value) {
                    console.log('handleRefund - packetTicket - value: ', value);
                    if (value.code !== 200) {
                        alert(value.message);
                    }
                })
                    .catch(function (error) {
                    console.log('handleRefund - packetTicket - error: ', error);
                });
                return [2 /*return*/];
            });
        }); };
        return _this;
    }
    PacketTicketDetail.prototype.UNSAFE_componentWillMount = function () {
        // console.log('UNSAFE_componentWillMount')
        if (!this.props.item && history.location.state === undefined) {
            history.goBack();
        }
    };
    PacketTicketDetail.prototype.componentDidMount = function () {
        // console.log('PacketTicketDetail - componentDidMount')
    };
    PacketTicketDetail.prototype.handleScan = function () { };
    PacketTicketDetail.prototype.render = function () {
        var _this = this;
        var item = history.location.state || this.props.item;
        var externalCloseBtn = React.createElement("button", { className: "close", style: { color: theme.color.primary, position: 'absolute', top: '50px', right: '15px', fontSize: 60, opacity: 1 }, onClick: this.props.onToggle || this.handleOnToggle }, "\u00D7");
        var itemList = [];
        var packetTicket = {};
        Object.assign(packetTicket, item);
        // packetTicket.image = `${process.env.REACT_APP_SERVER}${item.image}`
        itemList.push(packetTicket);
        // añadimos ticket que rectifica si procede
        if (item.ticketRefunded) {
            var temp = {};
            Object.assign(temp, item.ticketRefunded);
            temp.image = packetTicket.image;
            temp.tickets = packetTicket.tickets;
            itemList.push(temp);
        }
        console.log('itemList', itemList);
        return (React.createElement("div", { className: "animated fadeIn" },
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Modal, { centered: true, fade: true, isOpen: true, modalTransition: { timeout: 700 }, backdropTransition: { timeout: 1000 }, toggle: this.props.onToggle ? this.props.onToggle : this.handleOnToggle, external: externalCloseBtn, style: __assign({}, widthFunc(itemList.length, _width)) },
                        React.createElement(ModalBody, { style: { padding: 0 } },
                            React.createElement("div", { style: { display: 'flex', flexDirection: 'row', width: '100%' } }, itemList.map(function (value, index) { return (React.createElement(PacketTicketPapel, { item: value, key: value.numero, onRefunded: _this.handleOnRefunded })); }))))))));
    };
    PacketTicketDetail = __decorate([
        inject('store'),
        observer
    ], PacketTicketDetail);
    return PacketTicketDetail;
}(Component));
export default PacketTicketDetail;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/containers/PacketTicketDetail.tsx
// module id = 253
// module chunks = 0